var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":_vm.$t('aice.llm'),"isShowResStatusTab":"","status-opts":_vm.statusOpts,"status-click-handle":_vm.statusClickHandle}}),_c('page-body',[_c('list',{attrs:{"id":_vm.listId,"filterParams":_vm.filterParams,"statusResKey":"server"},on:{"resStatisticsChange":_vm.resStatisticsChange}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }